<template>
    <a-select
        v-model="loading ? 'loading' : selectedHookId"
        :filter-option="false"
        :notFoundContent="$t('chatbotv2.noWebhookFound')"
        class="w-100 webhook-picker"
        :placeholder="$t('chatbotv2.chooseAWebhook')"
        show-search
        size="large"
        @change="handleChange"
        @search="handleSearch"
        @select="handleSelect"
    >
        <a-select-option v-if="loading" :key="'loading'"> {{ $t("chatbotv2.loading") }} ....</a-select-option>
        <a-select-option v-for="(hook, index) of getFilteredResult()" :key="index" :value="hook._id">
            <div class="item-container">
                <div class="title">
                    <div class="logo-container">
                        <a-avatar :style="`background-color:${index % 2 === 0 ? '#c980a3' : '#6899c1'}`" class="avatar">
                            {{ hook.name.slice(0, 2).toUpperCase() }}
                        </a-avatar>
                    </div>
                    <div class="content">{{ hook.name }}</div>
                </div>
            </div>
        </a-select-option>
    </a-select>
</template>

<script>
import { mapActions } from "vuex";
import log2 from "../../../../../../utils/log2";
import _ from "lodash";

const log = log2("WebhookPicker");
export default {
    name: "WebhookPicker",
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            webhooks: [],
            loading: true,
            selectedHookId: this.value,
            query: null,
        };
    },
    methods: {
        ...mapActions({
            fetchUserWebHooks: "CB/fetchUserWebHooks",
        }),
        handleChange(hookId) {
            log(`selected ${hookId}`);
            this.selectedHookId = hookId;
            this.query = "";
        },
        handleSelect(hookId) {
            log(`handleSelect ${hookId}`);
            this.selectedHookId = hookId;
        },
        handleSearch(search) {
            log(`handleSearch ${search}`);
            this.query = search;
        },
        getFilteredResult() {
            const q = (this.query || "").trim().toLowerCase();
            const result = this.webhooks.filter((hook) => {
                return _.isEmpty(q) || (hook.name || "").toLowerCase().includes(q);
            });
            log("getFilteredResult", result);
            return result;
        },
    },
    mounted() {
        this.loading = true;
        this.fetchUserWebHooks()
            .then((res) => {
                this.webhooks = res;
            })
            .finally(() => {
                this.loading = false;
            });
    },
    watch: {
        selectedHookId(newValue) {
            this.$emit("input", newValue);
        },
        value(newValue) {
            if (this.selectedHookId !== newValue) {
                this.selectedHookId = newValue;
            }
        },
    },
};
</script>

<style lang="scss">
.webhook-picker {
    .ant-select-selection-selected-value {
        width: 100%;
    }
}

.item-container {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    align-items: center;
    width: 100%;

    .title {
        display: flex;

        .logo-container {
            .avatar {
            }
        }

        .content {
            margin-left: 10px;
            font-size: 18px;
            font-weight: 500;
        }
    }

    .content {
    }
}
</style>
